import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/home/index.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',//改为history模式，去除url里的#
  routes: [
    { path: "/", redirect: "/home" },
    { path: "/home", component: Home },
    // {
    //   path: '/404',
    //   component: () => import('@/view/404'),
    //   hidden: true
    // },
    // { path: '*', redirect: '/404', hidden: true },
    {
      path: '/message',
      component: () => import('@/view/message/index'),
      hidden: true
    },
    // { path: '*', redirect: '/message', hidden: true },
    // {
    //   path: '/',
    //   redirect: '/home',
    //   component: () => import('@/view/home/index'),
    //   children: [{
    //     path: '/home',
    //     name: 'home'
    //   }]
    // },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/view/product/index')
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('@/view/solution/index')
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('@/view/business/index')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('@/view/download/index')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/view/aboutUs/index')
    },
    {
      path: '/aboutVant',
      name: 'aboutVant',
      component: () => import('@/view/aboutVant/index.vue')
    }
  ]
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   // console.log('beforeEach:',to)
//   let navigation = JSON.parse(sessionStorage.getItem('navigation'))
//   // if (to.name !== 'home' && !navigation) {
//   //   next({ name: 'home' })
//   // } else
//   // next()
//   if(to.name=='aboutVant'){
//     next()
//   }else if(to.name!=='home' && !navigation){
//     next({ name: 'home' })
//   }else{
//     next()
//   }
// })

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  // // 检查to.matched是否为空，如果为空表示没有找到匹配的路由
  if (to.matched.length === 0) {
    // 重定向到/outside，并将未匹配的路径作为参数传递
    next({
      path: '/message',
      query: { path: to.path }, // 或者使用params，取决于outside页面如何接收参数
    });
  } else {
    if (window.location.hostname.endsWith('qimysafe.cn')) {
      const newDomain = 'www.qimysafe.com';
      const newUrl = `${window.location.protocol}//${newDomain}`;
      // 使用replace避免浏览器历史记录问题
      window.location.replace(newUrl);
      return;
    }
    next();
  }

});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js